import { Card, CardContent, CardDescription, CardHeader, CardTitle } from '@/components/ui/card';
import { Activity } from 'lucide-react';
import type { ManagerIntelligenceStats } from '@/hooks/useManagerIntelligenceStats';

interface Props { stats: ManagerIntelligenceStats | null | undefined; isSelfView: boolean; }

export function ManagerSystemHealth({ stats }: Props) {
  const formatRate = (r: number | null) => r != null ? `${Math.round(r * 100)}%` : '—';
  
  return (
    <Card>
      <CardHeader>
        <CardTitle className="text-lg flex items-center gap-2"><Activity className="h-5 w-5" />System Health</CardTitle>
        <CardDescription>Overall shop schedule and operational health indicators</CardDescription>
      </CardHeader>
      <CardContent className="grid grid-cols-1 md:grid-cols-3 gap-4">
        <div className="p-3 bg-muted/30 rounded-lg text-center">
          <div className="text-2xl font-bold">{formatRate(stats?.parkingLotEfficiency)}</div>
          <div className="text-xs text-muted-foreground">Parking Lot Efficiency</div>
        </div>
        <div className="p-3 bg-muted/30 rounded-lg text-center">
          <div className="text-2xl font-bold">{formatRate(stats?.eodScheduleHealth)}</div>
          <div className="text-xs text-muted-foreground">EOD Schedule Health</div>
        </div>
        <div className="p-3 bg-muted/30 rounded-lg text-center">
          <div className="text-2xl font-bold">{formatRate(stats?.reworkTrend)}</div>
          <div className="text-xs text-muted-foreground">Rework Trend</div>
        </div>
      </CardContent>
    </Card>
  );
}
